import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Person } from '../model/person';
import { Observable } from 'rxjs';
import { SessionHelper } from "@src/app/helpers/sessionHelper";
import { environment } from '@src/environments/environment';
import { Personorg } from '../model/personorg';

@Injectable({
  providedIn: 'root'
})
export class PersonService {
 // profileUrl:string = 'https://wfeg6h9q40.execute-api.eu-central-1.amazonaws.com/default/person/';
  personUrl:string = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/';
  
  constructor(private http:HttpClient) { }

 
  getPerson(personId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = `${this.personUrl}${personId}`;
    return this.http.get<Person>(urlCombo,httpOptions);
  }

  updatePerson(person:Person){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = `${this.personUrl}${person.personId}`;
    var profile= JSON.stringify(person);
    return this.http.put(urlCombo,profile,httpOptions);
  }
  getPersonOrgs(personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json' 
      })
    }
    return this.http.get<Personorg[]>(environment.apiUrl+'/person/'+personId+'/organization/list',httpOptions);
  }

}